import React from 'react';
import {
  TableCell,
  TableRow
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { subscriptionStatus } from 'helpers/customerSubscriptions';
import { convertUTCDateToLocalDate } from 'helpers/date';
import { format } from 'date-fns';


export const HistoryRowCollapsible = ({customerSubscriptionHistoryData, headTableCells}) => {
  const {
    status,
    description,
    created_at,
    order_increment_id,
    extension_attributes: {
      changed_by
    }
  } = customerSubscriptionHistoryData;

  const columns = headTableCells.reduce((acc, column) => {
    acc[column.label] = column;

    return acc;
  }, {});

  const createdDate = convertUTCDateToLocalDate(created_at || new Date());
  const formatedCreatedDate = format(createdDate, 'MM/dd/yyyy hh:mm:ss aa');

  return (
    <TableRow>
      {columns['Date']?.display && <TableCell>{formatedCreatedDate}</TableCell>}
      {columns['Subscription Status']?.display && <TableCell>{subscriptionStatus[status]}</TableCell>}
      {columns['Order Id']?.display &&
        <TableCell>
          <Link className="text-primary underline" to={{pathname: '/orders/list', state: {orderId: order_increment_id}}}>
            {order_increment_id}
          </Link>
        </TableCell>
      }
      {columns['Changed By']?.display && <TableCell>{changed_by}</TableCell>}
      {columns['Description']?.display && <TableCell>{description}</TableCell>}
    </TableRow>
  );
};

export default HistoryRowCollapsible;
